<script setup>
import {ref, computed} from 'vue'
import Button from "@/common/Button.vue"

const props = defineProps({
    options: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['hide-modal'])

// --- State ---

const input = ref('')

// Unpack options for easier access
const confirmStr = props.options.confirmStr
const onConfirm = props.options.onConfirm

// --- Computed ---

const isDisabled = computed(() => {
    return input.value !== confirmStr
})

// --- Methods ---

const onSubmit = () => {
    emit('hide-modal')
    if (onConfirm) {
        onConfirm()
    }
}
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div v-if="options.modalTitle" class="modal-header">
                <h4 class="modal-title">{{ options.modalTitle }}</h4>
                <button aria-label="Close" class="btn-close" type="button" @click="$emit('hide-modal')"></button>
            </div>

            <div class="modal-body">
                <div v-html="options.modalBody"></div>

                <form v-if="confirmStr" @submit.prevent="onSubmit">
                    <p class="mt-3">
                        Please type <strong>{{ confirmStr }}</strong> to confirm.
                    </p>

                    <p>
                        <input v-model="input" v-select v-focus autocomplete="off" class="form-control" type="text">
                    </p>

                    <p>
                        <button :disabled="isDisabled" class="btn btn-danger mt-2 w-100">
                            I understand the consequences, confirm delete.
                        </button>
                    </p>
                </form>
            </div>

            <div v-if="!confirmStr" class="modal-footer text-end">
                <Button @click="$emit('hide-modal')">Cancel</Button>

                <Button :default-class="'btn-warning'" @click="onSubmit" v-focus>
                    OK
                </Button>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Ensure the bold confirm string stands out */
strong {
    color: var(--bs-danger);
}
</style>